import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { JsonHttpService } from '../../shared/http/json-http.service'
import { ContentTypeGroup } from '../models/content-type-group';

@Injectable({
    providedIn: 'root'
})
export class ContentTypeService {
    constructor(private httpService: JsonHttpService) { }

    getContentTypeGroups(): Promise<ContentTypeGroup[]> {
        return this.httpService.get('api/configuration/contenttype/get-contenttypegroups').toPromise();
    }
}
